import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'translate';
import Tooltip from 'rc-tooltip';

import StyledLinkGeneration from './styles/LinkGeneration.styles';
import Preloader from './Preloader.jsx';

const LinkGeneration = ({
  arcsQuotaPerReferrer, className, isLoading, isMobile, onSubmit, referralHash, showNotice,
}) => {
  const isTooltipSeenOnMobile = useRef(false);
  const isTouchAvailable = useRef(false);
  const onTouchStart = () => {
    isTouchAvailable.current = true;
    if (isTooltipSeenOnMobile.current) {
      onSubmit();
      return;
    }
    isTooltipSeenOnMobile.current = true;
  };
  const onClick = () => {
    if (!isTouchAvailable.current) {
      onSubmit();
    }
  };

  return (
    <StyledLinkGeneration
      className={className}
      isMobile={isMobile}
    >
      {(showNotice && !referralHash && !isLoading) && (
        <Tooltip
          overlayClassName="twokey-tooltip-wrap secondary-theme"
          placement="top"
          animation="zoom"
          trigger={(showNotice) ? ['hover'] : []}
          mouseLeaveDelay={0.1}
          overlay={<FormattedMessage id="campaign_pay_it_forward.only_one_link" />}
        >
          <button
            className={`generate-link ${isLoading ? 'loading' : ''}`}
            onTouchStart={onTouchStart}
            onClick={onClick}
            disabled={isLoading}
          >
            <FormattedMessage id="campaign_pay_it_forward.generate_your_link" />
          </button>
        </Tooltip>)}
      <Preloader
        isManual={showNotice}
        referralHash={referralHash}
        isLoading={isLoading}
        arcsQuotaPerReferrer={arcsQuotaPerReferrer}
        isMobile={isMobile}
      />
    </StyledLinkGeneration>
  );
};

LinkGeneration.propTypes = {
  arcsQuotaPerReferrer: PropTypes.number,
  className: PropTypes.string,
  isLoading: PropTypes.bool,
  isMobile: PropTypes.bool,
  onSubmit: PropTypes.func,
  referralHash: PropTypes.string,
  showNotice: PropTypes.bool,
};

LinkGeneration.defaultProps = {
  className: '',
};

export default LinkGeneration;
